import { render } from "./Iban.vue?vue&type=template&id=2f59381a"
import script from "./Iban.vue?vue&type=script&lang=js"
export * from "./Iban.vue?vue&type=script&lang=js"

import "./Iban.vue?vue&type=style&index=0&id=2f59381a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__